import { render, staticRenderFns } from "./Codigo.vue?vue&type=template&id=af1010da&scoped=true"
import script from "./Codigo.vue?vue&type=script&lang=js"
export * from "./Codigo.vue?vue&type=script&lang=js"
import style0 from "./Codigo.vue?vue&type=style&index=0&id=af1010da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1010da",
  null
  
)

export default component.exports